import React from "react";

import CheckoutSubscription from "../../components/screen/profile/CheckoutSubscription";
import SidebarComponents from "../../components/ui/SidebarComponents";
import Header from "../../components/ui/Header";
import { SIDEBAR_WIDTH } from "../../components/constants/constant";

const CheckoutSubscriptionPage = () => {
  return (
    <div className="">
      <div className="flex">
          <SidebarComponents />       
        <div className={`w-[100%] lg:w-[calc(100%-${SIDEBAR_WIDTH}px)] p-3 overflow-hidden`}>
          <Header />
          <CheckoutSubscription />
        </div>
      </div>
    </div>
  );
};

export default CheckoutSubscriptionPage;
